import { useEffect, useState } from "react";
import { contactSupport } from "../../services/vesselService";
import ModalAlert from "./ModalAlert";

const ModalContactSupport = ({
	isOpen,
	closeModal,
	displayStarlinkOptions,
	liststarlink,
	siteName = "this site",
	token,
	dispatch,
	navigate,
}) => {
	const [selectedSubject, setSelectedSubject] = useState("Contact Support");
	const [message, setMessage] = useState("");
	const [isSending, setIsSending] = useState(false);
	const [selectedStarlink, setSelectedStarlink] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [showSuccessModal, setShowSuccessModal] = useState(false);
	const [showErrorModal, setShowErrorModal] = useState(false);
	useEffect(() => {
		if (isOpen) {
			setSelectedSubject("Contact Support");
			setMessage("");
			setSelectedStarlink("");
			setErrorMessage("");
		}
	}, [isOpen]);

	if (!isOpen) return null;

	const handleSubjectChange = (event) => {
		setSelectedSubject(event.target.value);
	};

	const handleMessageChange = (event) => {
		setMessage(event.target.value);
	};

	const handleStarlinkChange = (event) => {
		setSelectedStarlink(event.target.value);
	};

	const isFormValid = () => {
		return selectedSubject && message && (!displayStarlinkOptions || selectedStarlink);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		const data = {
			subject: selectedSubject,
			message,
			kit_number: selectedStarlink,
		};

		setIsSending(true);
		try {
			const response = await contactSupport(token, data, dispatch, navigate);

			if (response.status === 200) {
				setShowSuccessModal(true);

				setTimeout(() => {
					setShowSuccessModal(false);
					closeModal();
				}, 2000);
			} else if (response.status === 400) {
				setErrorMessage(response.data.error);
				setShowErrorModal(true);
			}
		} catch (error) {
			console.error("Error contacting support:", error);
			setErrorMessage("An error occurred while sending your message.");
		} finally {
			setIsSending(false);
		}
	};

	return (
		<div
			id="deleteModal"
			tabIndex="-1"
			aria-hidden="true"
			className="fixed top-0 right-0 left-0 z-50 flex h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-75 p-4 md:inset-0"
		>
			<div className="relative max-h-full w-full max-w-md p-4">
				<div className="relative rounded-lg bg-modal-bg shadow">
					<div className="flex items-center justify-between rounded-t border-gray-600 border-b p-4 md:p-5">
						<h3 className="font-semibold text-lg text-white">Enter your message</h3>
						<button
							type="button"
							className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-gray-400 text-sm hover:bg-dropdown-hover hover:text-white"
							data-modal-toggle="crud-modal"
							onClick={closeModal}
						>
							<svg
								className="h-3 w-3"
								aria-hidden="true"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 14 14"
							>
								<path
									stroke="currentColor"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
								/>
							</svg>
							<span className="sr-only">Close modal</span>
						</button>
					</div>
					{errorMessage && (
						<div className="mb-4 text-red-600 text-sm dark:text-red-400">{errorMessage}</div>
					)}
					<form className="p-4 md:p-5" onSubmit={handleSubmit}>
						<div className="mb-4 grid grid-cols-2 gap-4">
							<div className="col-span-2">
								<label
									htmlFor="subject"
									className="mb-2 flex justify-start font-medium text-sm text-white"
								>
									Subject <span className="text-red-500">*</span>
								</label>
								<select
									id="subject"
									className="block w-full rounded-lg bg-blue-gray bg-opacity-20 p-2.5 text-sm text-white placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500"
									value={selectedSubject}
									onChange={handleSubjectChange}
									required
								>
									<option
										value="Contact Support"
										className="bg-dropdown-bg hover:bg-dropdown-hover"
									>
										Contact Support
									</option>
									{displayStarlinkOptions && (
										<>
											<option
												value="Update Starlink Address"
												className="bg-dropdown-bg hover:bg-dropdown-hover"
											>
												Update Starlink Address
											</option>
										</>
									)}
								</select>
							</div>

							{displayStarlinkOptions && (
								<div className="col-span-2">
									<label
										htmlFor="starlink"
										className="mb-2 flex justify-start font-medium text-sm text-white"
									>
										Select Starlink Kit <span className="text-red-500">*</span>
									</label>
									<select
										id="starlink"
										className="block w-full rounded-lg border bg-blue-gray bg-opacity-20 p-2.5 text-sm text-white placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500"
										value={selectedStarlink}
										onChange={handleStarlinkChange}
										required
									>
										<option className="bg-dropdown-bg hover:bg-dropdown-hover" value="" disabled>
											Select Starlink Kit
										</option>
										{liststarlink.map((starlink, index) => (
											<option
												className="bg-dropdown-bg hover:bg-dropdown-hover"
												key={index}
												value={starlink.kit_number}
											>
												{starlink.kit_number}
											</option>
										))}
									</select>
								</div>
							)}

							<div className="col-span-2">
								<label
									htmlFor="message"
									className="mb-2 flex justify-start font-medium text-sm text-white"
								>
									Message <span className="text-red-500">*</span>
								</label>
								<textarea
									id="message"
									rows="4"
									className="block w-full rounded-lg border bg-blue-gray bg-opacity-20 p-2.5 text-sm text-white placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
									placeholder="Write message here"
									value={message}
									onChange={handleMessageChange}
									required
								></textarea>
							</div>
						</div>
						<button
							type="submit"
							className={`inline-flex items-center rounded-lg bg-button-bg px-5 py-2.5 text-center font-medium text-sm text-white hover:bg-button-hover focus:outline-none focus:ring-4 focus:ring-green-800 ${!isFormValid() ? "opacity-60" : ""}`}
							disabled={!isFormValid() || isSending}
						>
							{isSending ? "Sending..." : "Send"}
						</button>
					</form>
				</div>
			</div>
			<ModalAlert
				isOpen={showErrorModal}
				type="error"
				closeModal={() => setShowErrorModal(false)}
			/>
			<ModalAlert
				isOpen={showSuccessModal}
				type="success"
				closeModal={() => setShowSuccessModal(false)}
				message="Your message has been successfully sent."
			/>
		</div>
	);
};

export default ModalContactSupport;
